import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./styles/global.css";
import "./styles/layout.css";
import "./i18n";
import { router } from "./router";

const container = document.getElementById("app");

if (!container) {
  throw new Error("Root container #app not found");
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
